var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"albumResults"},[_c('ResultsPanel',{attrs:{"data":_vm.panelData,"preview":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }